import { ImportSummaryResponse } from '@interfaces/models';
import { create } from 'zustand';

type DialogType = 'SUMMARY' | 'UPLOAD' | 'REMOVE';

interface EmployeesMassImportStore {
  file: File | null;
  summary: ImportSummaryResponse | null;
  fileUploadError: string | null;
  dialogType: DialogType;
  isDownloadErrorFileLoading: boolean;
  isSaveImportLoading: boolean;
  isUploadFilePending: boolean;
  setIsDownloadErrorFileLoading: (isLoading: boolean) => void;
  setIsSaveImportLoading: (isLoading: boolean) => void;
  setIsUploadFilePending: (isPending: boolean) => void;
  setFile: (file: File | null) => void;
  setSummary: (summary: ImportSummaryResponse | null) => void;
  setFileUploadError: (error: string) => void;
  removeImport: () => void;
  showSummary: () => void;
  resetFile: () => void;
  setDialogType: (dialogType: DialogType) => void;
}

export const useEmployeesMassImportStore = create<EmployeesMassImportStore>((set) => {
  return {
    file: null,
    summary: null,
    fileUploadError: null,
    dialogType: 'UPLOAD',
    isDownloadErrorFileLoading: false,
    isSaveImportLoading: false,
    isUploadFilePending: false,

    resetFile: () => {
      set({
        file: null,
        dialogType: 'UPLOAD',
        summary: null,
        fileUploadError: null,
        isUploadFilePending: false,
        isSaveImportLoading: false,
        isDownloadErrorFileLoading: false,
      });
    },
    removeImport: () => {
      set({ dialogType: 'REMOVE' });
    },
    showSummary: () => {
      set({ dialogType: 'SUMMARY' });
    },
    setFileUploadError: (error: string) => {
      set({ fileUploadError: error });
    },
    setIsDownloadErrorFileLoading: (isLoading: boolean) => {
      set({ isDownloadErrorFileLoading: isLoading });
    },
    setIsSaveImportLoading: (isLoading: boolean) => {
      set({ isSaveImportLoading: isLoading });
    },
    setIsUploadFilePending: (isPending: boolean) => {
      set({ isUploadFilePending: isPending });
    },
    setFile: (file: File | null) => {
      set({ file });
    },
    setDialogType: (dialogType: DialogType) => {
      set({ dialogType });
    },
    setSummary: (summary: ImportSummaryResponse | null) => {
      set({ summary });
    },
  };
});
